import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { deletePack } from '../actions';
import PackColumn from './PackColumn';
import { Table, TableHeader, TableBody, TableHeaderColumn, TableRow } from 'material-ui/Table';
import { grey50 } from 'material-ui/styles/colors';

const EmptyPacks = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 200px);
`;

const tableHeaderStyle = {
    backgroundColor: grey50
};

function PacksList({ packs = {}, listPacks = [], deletePack }) {
    if (!listPacks.length) {
        return (
            <EmptyPacks>
                <h2>There are no packs currently. Create the first one.</h2>
            </EmptyPacks>
        );
    }

    return (
        <Table selectable={false} hoverable={false}>
            <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                enableSelectAll={false}
                style={tableHeaderStyle}
            >
                <TableRow>
                    <TableHeaderColumn>Title</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false} showRowHover={false} deselectOnClickaway={false}>
                {listPacks.map(packId => <PackColumn key={packId} pack={packs[packId]} deletePack={deletePack} />)}
            </TableBody>
        </Table>
    );
}

PacksList.propTypes = {
    // From connect
    packs: PropTypes.object.isRequired,
    listPacks: PropTypes.array.isRequired,
    deletePack: PropTypes.func.isRequired
};

export default connect(
    ({
        requery = {
            entities: {},
            list: {}
        }
    }) => ({
        packs: requery.entities.packs || {},
        listPacks: requery.list.packs || []
    }),
    { deletePack }
)(PacksList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/PacksList.js
 **/